module.exports = __webpack_public_path__ + "static/img/pic_2.7394048.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_2.jpeg
// module id = VLGN
// module chunks = 1